module.exports = __webpack_public_path__ + "img/image-04.0ee11fb1.jpg";